<template>
  <div class="label-list">
    <div
      v-if="!readonly"
      class="label-edit"
    >
      <el-input
        v-if="showInput"
        v-model="value"
        placeholder="请输入内容"
        size="mini"
        maxlength="10"
        show-word-limit
        @change="changeInput"
      />
      <el-button
        v-else
        size="mini"
        type="info"
        plain
        @click="addLabel"
      >
        + 添加
      </el-button>
    </div>
    <div
      v-for="(item, index) in labelList"
      :key="index"
      class="label"
      @click="selectLabel(item, index)"
    >
      <el-tag
        :effect="item.selected ? 'light' : 'plain'"
        :type="item.selected ? '' : 'info'"
        :size="tagSize"
      >
        {{ item.title }}
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpLabelList',
  props: {
    labelList: {
      type: Array
    },
    tagsId: {
      type: Number,
      default: 0
    },
    selectionBabel: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    tagSize: {
      type: String,
      default: 'medium'
    }
  },
  data () {
    return {
      showInput: false,
      value: ''
    }
  },
  methods: {
    addLabel () {
      this.value = ''
      this.showInput = true
    },
    changeInput (value) {
      this.showInput = false
      if (value) {
        this.createChildrenTags(value)
      }
    },
    async createChildrenTags (value) {
      const data = await this.$api.customer.createChildrenTags({
        tags_id: this.tagsId,
        children_title: value
      })
      if (data) {
        this.$message.success('创建成功')
        this.labelList.push(data)
        // this.$emit('createChildTags', this.labelList)
      }
    },
    selectLabel (item, index) {
      if (this.selectionBabel) {
        this.$set(this.labelList, index, {
          ...item,
          selected: !item.selected
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 22px;
  .label-edit {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .label {
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    user-select: none;
  }
}
</style>
